import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useOpportunitiesStore} from "../../store/opportunities.store";

export const useOpportunity = () => {
    const setOpportunity = useOpportunitiesStore((state) => state.setOpportunity);

    return useMutation(PartnerApi.opportunity, {
        onSuccess: (data) => {
            setOpportunity(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};